<div class="tw:h-dvh tw:flex tw:flex-col">
	<app-customer-support-mode-alert />
	<app-password-expiry-alert />
	<div class="tw:grow tw:relative tw:bg-[#f2f2f2]">
		<app-side-menu />
		<div class="tw:absolute tw:left-0 tw:lg:left-(--side-menu-width) tw:top-0 tw:right-0">
			<app-topbar />
		</div>
		<div
			class="tw:absolute tw:lg:left-(--side-menu-width) tw:left-0 tw:top-(--topbar-height) tw:bottom-0 tw:right-0 tw:overflow-y-auto tw:overflow-x-hidden"
		>
			<router-outlet />
		</div>
	</div>
</div>
<app-bottom-menu />
